var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 11.6213V19.5H8.5V16C8.5 14.067 10.067 12.5 12 12.5C13.933 12.5 15.5 14.067 15.5 16V19.5H19.5V11.6213L12 4.12129L4.5 11.6213ZM11.2929 2.70708C11.6834 2.31655 12.3166 2.31655 12.7071 2.70708L20.7071 10.7071C20.8946 10.8946 21 11.149 21 11.4142V20C21 20.5523 20.5523 21 20 21H15C14.4477 21 14 20.5523 14 20V16C14 14.8954 13.1046 14 12 14C10.8954 14 10 14.8954 10 16V20C10 20.5523 9.55228 21 9 21H4C3.44772 21 3 20.5523 3 20V11.4142C3 11.149 3.10536 10.8946 3.29289 10.7071L11.2929 2.70708Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/HomeIcon.405d4973eaa2649f0e575fd9c7e32b62.svg";
export { ForwardRef as ReactComponent };